// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"16869501","848":"4ead4ce7"}[chunkId] + ".chunk.js";
};